import React from "react";
import { Switch, Route } from "react-router-dom";
import "./Order.scss";

import OrdersPage from "./OrdersPage";
import OrderPage from "./OrderPage";
import NewOrderPage from "./NewOrderPage";

const Orders = () => (
  <Switch>
    <Route path="/dispatch/orders/new">
      <NewOrderPage />
    </Route>
    <Route path="/dispatch/orders/:id">
      <OrderPage />
    </Route>
    <Route path="/dispatch/orders">
      <OrdersPage />
    </Route>
  </Switch>
);

export default Orders;
